<template>
  <div>
    <b-skeleton-table
      v-if="isLoading"
      :rows="5"
      :columns="5"
    />

    <b-table
      v-if="!isLoading"
      ref="refInvoiceListTable"
      :items="registryUser.data"
      responsive
      :fields="tableFields"
      primary-key="id"
      show-empty
      empty-text="No matching records found"
      class="position-relative mh-160"
    >

      <!-- Column: Name -->
      <template #cell(name)="data">
        <div class="d-flex align-items-center">
          <b-avatar
            variant="primary"
            :text="initialText(data.item.name)"
            class="align-baseline"
            :src="linkStaging(data.item.photo)"
          />
          <span class="ml-1"> {{ data.item.name }}</span>
        </div>
      </template>

      <!-- Column: Registered -->
      <template #cell(registered)="data">
        <span class="text-nowrap">
          {{ data.item.registered }} Minggu yang lalu
        </span>
      </template>

      <!-- Column: Registry Produk Total -->
      <template #cell(total_registry_products)="data">
        <span
          class="text-nowrap"
          :class="!data.item.total_registry_products ? 'text-muted' : ''"
        >
          {{ data.item.total_registry_products ? `${data.item.total_registry_products}  Produk` : '0 Produk' }}
        </span>
      </template>

      <!-- Column: Purchased Registry Produk -->
      <template #cell(purchased_registry_products)="data">
        <span
          class="text-nowrap"
          :class="!data.item.purchased_registry_products ? 'text-muted' : ''"
        >
          {{ data.item.purchased_registry_products ? `${data.item.purchased_registry_products}  Produk` : '0 Produk' }}
        </span>
      </template>

      <!-- Column: Purchased External Produk -->
      <template #cell(purchased_external_products)="data">
        <span
          class="text-nowrap"
          :class="!data.item.purchased_external_products ? 'text-muted' : ''"
        >
          {{ data.item.purchased_external_products ? `${data.item.purchased_external_products}  Produk` : '0 Produk' }}
        </span>
      </template>

      <!-- Column: Aktivitas Terakhir -->
      <template #cell(lastActivity)="data">
        <span v-if="data.item.last_active_at">
          {{ formatSelectDate(data.item.last_active_at, ['date','month','year','time']) }}
        </span>
      </template>

      <!-- Column: Tanggal Pendaftaran -->
      <template #cell(date)="data">
        {{ formatDate(data.item.created_at) }}
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <div class="text-nowrap">
          <!-- Dropdown -->
          <table-action
            :actions="tableAction"
            :data="data"
          />
        </div>
      </template>

    </b-table>

    <div
      class="mx-2 mb-2"
    >
      <pagination
        :data="registryUser.meta"
        action="registry/getRegistryUser"
      />
    </div>

    <b-modal
      id="modal-user-detail"
      title="Detail Pengguna"
      hide-footer
    >
      <div v-if="userDetail">
        <user-detail :user="userDetail" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BTable,
  BSkeletonTable,
  BAvatar,
} from 'bootstrap-vue'
import { mapActions, mapState } from 'vuex'
import Pagination from '@/layouts/components/custom/Pagination.vue'
import TableAction from '@/layouts/components/custom/TableAction.vue'
import UserDetail from '@core/components/user/UserDetail.vue'

export default {
  components: {
    BTable,
    BSkeletonTable,
    BAvatar,

    UserDetail,
    Pagination,
    TableAction,
  },
  data() {
    return {
      tableFields: [
        { key: 'name', label: 'Nama' },
        { key: 'total_registry_products', label: 'Total Produk Registry' },
        { key: 'purchased_registry_products', label: 'Produk Registry Terbeli' },
        { key: 'purchased_external_products', label: 'Produk External Terbeli' },
        { key: 'lastActivity', label: 'Aktivitas Terakhir' },
        { key: 'registered', label: 'Register pada' },
        { key: 'actions', label: '' },
      ],
      userDetail: '',
    }
  },
  computed: {
    ...mapState('registry', ['registryUser', 'isLoading']),
    query() {
      return this.$route.query
    },
    tableAction() {
      return [
        {
          access: null,
          to: null,
          action: data => { this.showDetailModal(data) },
          icon: 'EyeIcon',
          title: 'Detail',
        },
        {
          access: null,
          to: null,
          action: data => { this.toExternalLink(`/registry/${data.username}`) },
          icon: 'GiftIcon',
          title: 'Lihat Registry',
        },
      ]
    },
  },
  async created() {
    await this.getRegistryUser(this.query)
  },
  methods: {
    ...mapActions('registry', ['getRegistryUser']),
    showDetailModal(item) {
      this.userDetail = item
      this.$bvModal.show('modal-user-detail')
    },
  },
}
</script>
